export enum RoleById {
	Director_de_Informática = 1,
	Director_de_Bienes_Fiscales = 2,
	Operador_de_Dirección_de_Bienes_Fiscales = 3,
	Encargado_Patrimonial = 4,
	Operador_Dependencia_Patrimonial = 5,
	Super_Admin = 6
}
